export class KeyCode {
  public static CANCEL: number = 3;
  public static HELP: number = 6;
  public static BACKSPACE: number = 8;
  public static TAB: number = 9;
  public static CLEAR: number = 12;
  public static RETURN: number = 13;
  public static ENTER: number = 14;
  public static SHIFT: number = 16;
  public static CONTROL: number = 17;
  public static ALT: number = 18;
  public static PAUSE: number = 19;
  public static CAPS_LOCK: number = 20;
  public static ESCAPE: number = 27;
  public static SPACE: number = 32;
  public static PAGE_UP: number = 33;
  public static PAGE_DOWN: number = 34;
  public static END: number = 35;
  public static HOME: number = 36;
  public static LEFT: number = 37;
  public static UP: number = 38;
  public static RIGHT: number = 39;
  public static DOWN: number = 40;
  public static PRINTSCREEN: number = 44;
  public static INSERT: number = 45;
  public static DELETE: number = 46;
  public static KEY0: number = 48;
  public static KEY1: number = 49;
  public static KEY2: number = 50;
  public static KEY3: number = 51;
  public static KEY4: number = 52;
  public static KEY5: number = 53;
  public static KEY6: number = 54;
  public static KEY7: number = 55;
  public static KEY8: number = 56;
  public static KEY9: number = 57;
  public static SEMICOLON: number = 59;
  public static EQUALS: number = 61;
  public static A: number = 65;
  public static B: number = 66;
  public static C: number = 67;
  public static D: number = 68;
  public static E: number = 69;
  public static F: number = 70;
  public static G: number = 71;
  public static H: number = 72;
  public static I: number = 73;
  public static J: number = 74;
  public static K: number = 75;
  public static L: number = 76;
  public static M: number = 77;
  public static N: number = 78;
  public static O: number = 79;
  public static P: number = 80;
  public static Q: number = 81;
  public static R: number = 82;
  public static S: number = 83;
  public static T: number = 84;
  public static U: number = 85;
  public static V: number = 86;
  public static W: number = 87;
  public static X: number = 88;
  public static Y: number = 89;
  public static Z: number = 90;
  public static CONTEXT_MENU: number = 93;
  public static NUMPAD0: number = 96;
  public static NUMPAD1: number = 97;
  public static NUMPAD2: number = 98;
  public static NUMPAD3: number = 99;
  public static NUMPAD4: number = 100;
  public static NUMPAD5: number = 101;
  public static NUMPAD6: number = 102;
  public static NUMPAD7: number = 103;
  public static NUMPAD8: number = 104;
  public static NUMPAD9: number = 105;
  public static MULTIPLY: number = 106;
  public static ADD: number = 107;
  public static SEPARATOR: number = 108;
  public static SUBTRACT: number = 109;
  public static DECIMAL: number = 110;
  public static DIVIDE: number = 111;
  public static F1: number = 112;
  public static F2: number = 113;
  public static F3: number = 114;
  public static F4: number = 115;
  public static F5: number = 116;
  public static F6: number = 117;
  public static F7: number = 118;
  public static F8: number = 119;
  public static F9: number = 120;
  public static F10: number = 121;
  public static F11: number = 122;
  public static F12: number = 123;
  public static F13: number = 124;
  public static F14: number = 125;
  public static F15: number = 126;
  public static F16: number = 127;
  public static F17: number = 128;
  public static F18: number = 129;
  public static F19: number = 130;
  public static F20: number = 131;
  public static F21: number = 132;
  public static F22: number = 133;
  public static F23: number = 134;
  public static F24: number = 135;
  public static NUM_LOCK: number = 144;
  public static SCROLL_LOCK: number = 145;
  public static COMMA: number = 188;
  public static PERIOD: number = 190;
  public static SLASH: number = 191;
  public static BACK_QUOTE: number = 192;
  public static OPEN_BRACKET: number = 219;
  public static BACK_SLASH: number = 220;
  public static CLOSE_BRACKET: number = 221;
  public static QUOTE: number = 222;
  public static META: 224
}
